import { useEffect, useState } from 'react';

// custom hook for rendering components based on screen width
const useMedia = (query) => {
    const [matches, setMatches] = useState(false);
    useEffect(() => {
      const media = window.matchMedia(query);
      const listener = () => setMatches(media.matches);
      listener();
      media.addEventListener('change', listener);
  
      return () => media.removeEventListener('change', listener);
    }, [matches, query]);
    return matches;
  };

export default useMedia;